import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_CONFIG, AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment.prod';
import { InteractionType } from '@azure/msal-browser';


declare const Office: any;

function getInteractionType(): InteractionType {
  try {
    return window.self !== window.top
      ? InteractionType.Popup
      : InteractionType.Redirect;
  } catch {
    return InteractionType.Popup;
  }
}

const reqHeaders = new Headers();
reqHeaders.append('cache-control', 'max-age=3600');

fetch('/assets/config/env.config.json', { headers: reqHeaders })
  .then(response => response.json())
  .then(config => {
    config.msalInterceptorConfig.protectedResourceMap = new Map(config.msalInterceptorConfig.protectedResourceMap);
    const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
    config.msalConfig.cache.storeAuthStateInCookie = isIE;
	
	// Dynamic interaction type    
	const interactionType = getInteractionType();
	config.msalGuardConfig.interactionType = interactionType;
	config.msalInterceptorConfig.interactionType = interactionType;

    return config;
  })
  .then(config => {
    if (environment.production){
      enableProdMode();
    }

    const bootstrapModule = () => {
      platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }]).bootstrapModule(AppModule)
        .catch(err => console.error(err));
    };

    config.routerConfig = {
      useHash: false
    };

    bootstrapModule();

  });